(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SistemaDialogController', SistemaDialogController);

    SistemaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Sistema'];

    function SistemaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Sistema) {
        var vm = this;

        vm.sistema = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sistema.id !== null) {
                Sistema.update(vm.sistema, onSaveSuccess, onSaveError);
            } else {
                Sistema.save(vm.sistema, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:sistemaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
